import { ExtendableError } from "@/core/error"

class HasLessonsError extends ExtendableError {}

export { HasLessonsError }